import React, { useRef, useEffect, useState } from 'react';

import { Grid, Typography, Button } from '@material-ui/core';
import { makeStyles /*useTheme*/ } from '@material-ui/core/styles';
// import useMediaQuery from '@material-ui/core/useMediaQuery';

import Header from '../common-header/Header';
import menuIcon from '../../assets/menuIcon.svg';
import closeButton from '../../assets/closeIcon.svg';

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

const useStyles = makeStyles((theme) => ({
  navBarWrapper: {
    width: '100%',
    position: 'fixed',
    top: 0,
    left: 0,
    zIndex: 10
  },
  headerCont: {
    width: '100%'
  },
  navCont: {
    padding: '1.2rem 2rem'
  },
  logoCont: {
    width: '15%'
  },
  playTrailerCont: {
    width: '30%',
    marginLeft: 'auto'
  },
  playButton: {
    ...theme.typography.button,
    marginLeft: '1rem'
  },
  drawerWrapper: {
    width: '35.4%',
    height: '100vh',
    zIndex: 11,
    position: 'fixed',
    display: 'none',
    borderLeft: '2px solid #fff',
    right: 0,
    top: 0,
    backgroundColor: `rgba(0,0,0,.9)`
  },
  drawerCont: {
    padding: '6rem 2.5rem'
  },
  closeButtonCont: {
    position: 'absolute',
    width: '32px',
    right: '4rem',
    top: '2rem'
  },
  singleLink: {
    marginTop: '2.4rem'
  },
  playTrailerButtonCont: {
    backgroundColor: 'none',
    width: '100%'
  },
  playTrailerButton: {
    backgroundColor: 'transparent',
    border: 'none'
  },
  border: {
    width: '5rem',
    marginTop: '2.4rem',
    borderTop: '1px solid #fff'
  },
  // --------------------------------------------------------
  label3: {
    ...theme.typography.label3,
    color: '#fff',
    textAlign: 'left'
  },
  button1: {
    ...theme.typography.button
  },
  button2: {
    ...theme.typography.button2,
    textTransform: 'none',
    textAlign: 'left'
  },
  label3Transparent: {
    ...theme.typography.label3,
    color: 'rgba(255, 255, 255, 0.6)',
    textAlign: 'left'
  },
  button2Transparent: {
    ...theme.typography.button2,
    color: 'rgba(255, 255, 255, 0.6)',
    textAlign: 'left',
    textTransform: 'none'
  }
}));

const navInfo = [
  {
    vidNum: '1',
    text1: 'Alabama',
    link: '#alabama',
    released: true
  },
  {
    vidNum: '2',
    text1: 'North Carolina',
    link: '#northCarolina',
    released: true
  },
  {
    vidNum: '3',
    text1: 'Virginia',
    link: '#virginia',
    released: true
  },
  {
    vidNum: '4',
    text1: 'Georgia',
    released: true,
    link: '#georgia'
  },
  {
    vidNum: '5',
    text1: 'Tennessee',
    released: true,
    link: '#tennessee'
  },
  {
    vidNum: '6',
    text1: 'Mississippi',
    released: false,
    link: '#comingSoon'
  }
];

const NavbarTab = () => {
  const classes = useStyles();
  //   const theme = useTheme();
  //   const matchesSM = useMediaQuery(theme.breakpoints.down('sm'));
  let containerRef = useRef(null);
  let [openDrawer, setOpenDrawer] = useState(false);

  const toggleDrawer = () => {
    const drawer = document.getElementById('drawer');
    if (!openDrawer) {
      drawer.style.display = 'block';
      setOpenDrawer(true);
    } else {
      drawer.style.display = 'none';
      setOpenDrawer(false);
    }
  };

  useEffect(() => {
    const showAnim = gsap
      .from(containerRef, {
        yPercent: -100,
        paused: true,
        duration: 0.2
      })
      .progress(1);
    ScrollTrigger.create({
      trigger: containerRef,
      start: 'top top',
      end: 99999,
      onUpdate: (self) => {
        self.direction === -1 ? showAnim.play() : showAnim.reverse();
      }
    });
  });
  return (
    <>
      <Grid
        ref={(el) => {
          containerRef = el;
        }}
        container
        direction="column"
        className={classes.navBarWrapper}
      >
        <Header />
        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
          className={classes.navCont}
        >
          <Grid
            container
            alignItems="center"
            justifyContent="flex-end"
            className={classes.playTrailerCont}
          >
            <Grid item className={classes.menuIconCont}>
              <Button
                onClick={() => {
                  toggleDrawer();
                }}
              >
                <img src={menuIcon} alt="circle with three dots" />
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid container id="drawer" className={classes.drawerWrapper}>
        <Grid container className={classes.drawerCont}>
          <Grid item className={classes.closeButtonCont}>
            <Button
              onClick={() => {
                toggleDrawer();
              }}
            >
              <img src={closeButton} alt="button with x" />
            </Button>
          </Grid>
          <Grid container direction="column" alignItems="flex-start" className={classes.linksCont}>
            <Grid item className={classes.playTrailerButtonCont}>
              <a
                href="#trailer"
                onClick={() => {
                  toggleDrawer();
                }}
              >
                <button className={classes.playTrailerButton}>
                  <Typography className={classes.button1}>Play Trailer</Typography>
                </button>
              </a>
            </Grid>
            <div className={classes.border} />
            {navInfo.map((link) => (
              <Grid key={link.vidNum} container className={classes.singleLink}>
                <a
                  href={link.link}
                  onClick={() => {
                    toggleDrawer();
                  }}
                >
                  <Button style={{ padding: 0 }}>
                    <Grid container>
                      <Typography
                        className={
                          link.released === true ? classes.label3 : classes.label3Transparent
                        }
                        style={{ width: '100%' }}
                      >
                        Episode {link.vidNum}
                      </Typography>
                      <Typography
                        className={
                          link.released === true ? classes.button2 : classes.button2Transparent
                        }
                        style={{ width: '100%' }}
                      >
                        {link.text1}
                      </Typography>
                    </Grid>
                  </Button>
                </a>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default NavbarTab;
